/**
 * Datadog RUM action name for keyboard shortcuts. This is a telemetry concept,
 * but it lives here because @frameio/telemetry depends on @frameio/utils, so
 * `useHotKeys` can't import it from telemetry without a circular dependency.
 * Telemetry re-exports it from here.
 */
export const KEYBOARD_SHORTCUT_ACTION_NAME = 'keyboard-shortcut';

export const HOTKEY = {
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_LEFT: 'ArrowLeft',
  C: 'c',
  F: 'f',
  G: 'g',
  I: 'i',
  J: 'j',
  K: 'k',
  L: 'l',
  M: 'm',
  O: 'o',
  P: 'p',
  R: 'r',
  S: 's',
  T: 't',
  Q: 'q',
  Y: 'y',
  Z: 'z',
  SPACE: ' ',
  ONE: '1',
  TWO: '2',
  THREE: '3',
  PLUS: '=',
  MINUS: '-',
  TAB: 'Tab',
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  META: 'Meta',
  META_NUM_ZERO: 'Meta0',
  META_CHAR_K: 'Metak',
  META_CHAR_Z: 'Metaz',
  SHIFT_META_CHAR_Z: 'ShiftMetaz',
  CONTROL: 'Control',
  CONTROL_CHAR_L: 'Controll',
  CONTROL_CHAR_MINUS: 'Control-',
  CONTROL_CHAR_PLUS: 'Control=',
  SHIFT: 'Shift',
  SHIFT_ARROW_RIGHT: 'ShiftArrowRight',
  SHIFT_ARROW_LEFT: 'ShiftArrowLeft',
  SHIFT_CHAR_J: 'ShiftJ',
  SHIFT_CHAR_L: 'ShiftL',
  SHIFT_CHAR_I: 'ShiftI',
  SHIFT_CHAR_O: 'ShiftO',
  // '+' requires Shift on a US keyboard layout. getKeyForEvent reports that
  // combination as the string 'Shift+' (Shift prefix + the '+' character),
  // never bare '+' -- so a hotkey meant to fire on '+' also needs this entry.
  SHIFT_CHAR_PLUS: 'Shift+',
};
